import React from "react";
import CustomWorkflowBuilder from "./CustomWorkflowBuilder";

const StepsContent = () => {
  return <CustomWorkflowBuilder />;
};

export default StepsContent;
